module.exports = __webpack_public_path__ + "img/ky.7c5ca408.svg";